// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"cd6fda52","43":"3727b762","130":"b82d9cff","137":"6f772a33","434":"87c79392","892":"be73317d","899":"412a72a3","950":"78ccf31c","981":"c964e4da"}[chunkId] + ".chunk.js";
};